import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface EventDispatcher {
  eventKey: string;
  event: Record<string, any>;
}

export enum EVENT_DISPATCHER_KEYS {
  FeedBackSubmitted = 'FeedBackSubmitted',
}

@Injectable({ providedIn: 'root' })
export class EventDispatcherService {
  #eventSubject = new Subject<EventDispatcher>();
  event$ = this.#eventSubject.asObservable();

  emitEvent(event: EventDispatcher) {
    if (EVENT_DISPATCHER_KEYS[event.eventKey]) {
      this.#eventSubject.next(event);
    }
  }
}
